<template>
  <cardTemplate :classCustom="'detail margin-top-10 margin-bottom-10 docin'">
    <template #content>
      <div class="header flex-row flex__left">
        <div class="margin-right-10">
          <img
            src="../../assets/img/symbol/docBook_cardIcon.svg"
            class="clickable"
            @click="$emit('viewMore')"
          />
        </div>
        <div
          class="rightSection width__100 padding-bottom-10 has-border__bottom"
        >
          <h3 class="tt1 clickable" @click="$emit('viewMore')">
            {{ cardTitle }}
          </h3>
          <span class="tt2"> </span>
        </div>
      </div>
      <div class="body margin-bottom-10 margin-top-10">
        <VuePerfectScrollbar
          class="scroll-body"
          :settings="perfectScrollbarSetting"
        >
          <div v-if="shareLibDocs && shareLibDocs.length">
            <div
              v-for="item in shareLibDocs"
              :key="item.Id"
              class="file-item flex-row flex-left margin-bottom-10 clickable"
            >
              <i
                class="far fa-file color__link font-size__small margin-bottom-10 margin-right-10"
              ></i>
              <span class="file-name has-border__bottom padding-bottom-10">
                <a @click="downloadFile(item)"
                >{{ item.title }} - {{ item.attachmentName }}
                </a>
              </span>
            </div>
          </div>
          <div v-else class="stateEmpty flex-col flex__center">
            <img
              src="../../assets/img/nothing.jpg"
              class="icon-not-found margin-bottom-10 margin-top-10"
            />
            <span class="font-size__small font-weight__bold opacity-50"
            >Không có dữ liệu</span
            >
          </div>
        </VuePerfectScrollbar>
        <div class="more clickable txt-center" @click="$emit('viewMore')">
          XEM THÊM
        </div>
      </div>
    </template>
  </cardTemplate>
</template>
<script>
  import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
  import constants from "../../constants";
  import downloadService from "../../services/downloadService";

  export default {
    mixins: [vbAttachmentTokenMixin],
    name: "ShareLibraryCard",
    props: ["cardTitle", "shareLibDocs"],
    components: {
      cardTemplate: () => import("../common/cardTemplate.vue"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar")
    },
    data() {
      return {
        perfectScrollbarSetting: {maxScrollbarLength: 350},
        DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
        DOWNLOAD_FILE_URL: constants.DOWNLOAD_FILE_URL
      };
    },
    methods: {
      downloadFile(shareLibrary) {
        downloadService.downloadShareLibrary(shareLibrary.attachmentId);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/dashboard/ShareLibraryCard.vue